import Vue from 'vue';
import {
    ValidationProvider,
    ValidationObserver,
    localize,
    extend,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import sv from 'vee-validate/dist/locale/sv';
import en from 'vee-validate/dist/locale/en';
import fi from 'vee-validate/dist/locale/fi';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// loop over all rules
Object.keys(rules).forEach((key) => {
    extend(key, {
        ...rules[key], // add the rule
    });
});

extend('lgh', (value) => {
    const length = value.toString().length;

    if (length > 0 && value.slice(-2) === '00') {
        return 'Lägenhetsnummer kan inte sluta på 00.';
    }

    if (length === 0 || length === 4) {
        return true;
    }

    return 'Lägenhetsnummer kan lämnas tomt eller anges med exakt 4 siffor.';
});

// import deInternal from './lang/de.json';
// import enInternal from './lang/en.json';

// var mergedDE = _.merge({}, de, deInternal);

localize({
    en,
    sv,
    fi,
});
localize('sv');
